import ShadesList from './ShadesList'

export default ShadesList
